/**
 *
 * @module amountedLineItem
 *
 */

import Check from 'check-types';
import AffiliateTracking from './affiliateTracking';
import LineItemAttribute from './lineItemAttribute';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    array,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class AmountedLineItem
 *
 */
export default class AmountedLineItem {

    /**
     *
     * @param {Object} options
     * @param {SDK.Services.Commerce.AffiliateTracking} [options.affiliateTracking=null]
     * @param {Array<SDK.Services.Commerce.LineItemAttribute>} options.attributes
     * @param {Boolean} [options.autoRenew=false]
     * @param {Number} [options.quantity=0]
     * @param {String} options.sku
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'AmountedLineItem(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get attributes() {
                return `${this.ctor} needs Array of SDK.Services.Commerce.LineItemAttribute`;
            },
            get sku() {
                return `${this.ctor} options.sku should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { affiliateTracking, attributes, autoRenew, quantity, sku } = options;

        array.of.instanceStrict(
            attributes,
            LineItemAttribute,
            errorMessage.attributes,
            InvalidArgumentException
        );

        nonEmptyString(sku, errorMessage.sku, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {SDK.Services.Commerce.AffiliateTracking}
         *
         */
        this.affiliateTracking = Check.instanceStrict(affiliateTracking, AffiliateTracking) ? affiliateTracking : null;

        /**
         *
         * @access public
         * @type {Array<SDK.Services.Commerce.LineItemAttribute>}
         *
         */
        this.attributes = attributes;

        /**
         *
         * @access public
         * @type {Boolean}
         *
         */
        this.autoRenew = Check.boolean(autoRenew) ? autoRenew : false;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.quantity = Check.number(quantity) ? quantity : 0;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.sku = sku;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/amountedLineItem.js